<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-body">
        <div class="modal-header">
          <img
            v-if="getChallengePicture() !== ''"
            :src="getChallengePicture()"
            class="challenge-image"
          />
          <div v-else class="blank-image"></div>
          <div class="challenge-details" v-if="viewChallengeDetails">
            <h3>{{ selectedChallenge.title.toUpperCase() }}</h3>
            <p>{{ selectedChallenge.description }}</p>
          </div>
          <div class="challenge-details" v-else-if="awardingChallenge">
            <h5 class="user-search-ttl">User Search</h5>
            <div class="search-field">
              <input 
                type="text" 
                placeholder="Search..." 
                v-model="userSearch"
                @change="searchUser()"/>
            </div>
            <div class="user-list">
              <div class="user" :key="user.id" v-for="user in $store.state.challenges.users" @click="selectUser(user)">
                <div class="user-details">
                  <h3>{{ user.first_name.toUpperCase() }} {{ user.last_name.toUpperCase() }}</h3>
                  <p>{{ user.email }}</p>
                </div>
              </div>
            </div>
          </div>
          <i class="fas fa-times" @click="closeModal()"></i>
        </div>
        <div v-if="viewChallengeDetails">
          <div class="modal-row">
            <div class="modal-input">
              <label>COMPLETED</label>
              <span class="completed">{{selectedChallenge.completed}}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>CATEGORY</label>
              <span>{{ selectedChallenge.category }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" v-if="viewChallengeDetails">
        <div class="top-row">
          <button class="secondary-btn-dark reset-password" @click="editChallenge()">
            EDIT CHALLENGE
          </button>
        </div>
      </div>
      <div class="modal-footer" v-else>
        <div v-if="selectedUser.id">
          <img
            v-if="getUserPicture(selectedUser) !== ''"
            :src="getUserPicture(selectedUser)"
            class="user-profile"
          />
          <div v-else class="blank-image"></div>
          <img class="icon" src="../../assets/profile_verified.png" v-if="selectedUser.verified">
          <img class="icon" src="../../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
          <div class="user-details">
            <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
            <p>{{ selectedUser.email }}</p>
            <p>{{ age }} - {{ selectedUser.gender }}</p>
            <p>{{ selectedUser.location }}</p>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>BIO</label>
              <span>{{selectedUser.bio}}</span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>LAST ACTIVE</label>
              <span>{{ formatDate(selectedUser.updated_at) }}</span>
            </div>
            <div class="modal-input">
              <label>REPORTED</label>
              <span><a :href="'/user_reports/'+selectedUser.id">{{selectedUser.reported}}</a></span>
            </div>
          </div>
          <div class="modal-row">
            <div class="modal-input">
              <label>ACCOUNT CREATED</label>
              <span>{{ formatDate(selectedUser.created_at) }}</span>
            </div>
            <div class="modal-input">
              <label>VERIFIED SINCE</label>
              <span>{{ formatDate(selectedUser.verified_at) }}</span>
            </div>
          </div>
          <div class="top-row">
            <button class="secondary-btn-dark reset-password" @click="closeModal()">
              CANCEL
            </button>
            <button class="primary-btn reset-password" @click="awardBadge()">
              AWARD BADGE
            </button>
          </div>
        </div>
        <div class="empty" v-else>
          <h4>Search for a user first</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils'
import { awardBadge } from '@/api/requests';
import { debounce } from "debounce";

export default {
  name: "ChallengeDetailModal",

  data() {
    return {
      warningModal: false,
      selectedTab: 'RESTRICT',
      restrictionType: '',
      restrictionDuration: '',
      userSearch: '',
    };
  },  

  methods: {
    closeModal() {
      this.$store.dispatch('challenges/challengeDetailsClosed');
    },

    getChallengePicture() {
      if (this.selectedChallenge.image !== "" && this.selectedChallenge.image !== null) {
        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + this.selectedChallenge.image;
      }
      return "";
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    searchUser: debounce(function (e) {
      this.$store.dispatch('challenges/searchUsers', this.userSearch);
    }, 400),

    selectUser(user) {
      this.$store.dispatch('challenges/selectUser', user);
    },

    getUserPicture(user) {
      if (user.image !== "" && user.image !== null) {
        if (user.image.indexOf('blob:') > -1) {
          return user.image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + user.image;
      }
      return "";
    },

    awardBadge() {
      this.$confirm(
        "Are you sure you want to award the badge to " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "?", 
        "AWARD BADGE").then(() => {
          let payload = {
            'id': this.selectedChallenge.id,
            'user_id': this.selectedUser.id,
          };
          awardBadge(this.selectedChallenge.id, payload).then(() => {
            this.$store.dispatch('reloadTable');
            this.$toasted.global.app_success({
              message: "Badge has been awarded."
            });
            this.closeModal();
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to award badge."
          });
        });
    },

    editChallenge() {
      this.$router.push({ name: 'ChallengeManagement', params: { creating: false, challenge: this.selectedChallenge } });
      this.closeModal();
    }
  },

  computed: {
    selectedChallenge() {
      return this.$store.state.challenges.selectedChallenge;
    },

    selectedUser() {
      return this.$store.state.challenges.selectedUser;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    viewChallengeDetails: {
      get () {
        return this.$store.state.challenges.viewChallengeDetails
      },
      set (value) {
        this.$store.dispatch('challenges/challengeClicked', value);
      }
    },

    awardingChallenge: {
      get () {
        return this.$store.state.challenges.awardingChallenge
      },
      set (value) {
        this.$store.dispatch('challenges/challengeClicked', value);
      }
    },

    users() {
      return this.$store.state.challenge.users;
    },

    age() { 
      let diff_ms = Date.now() - Date.parse(this.selectedUser.birthday);
      let age_dt = new Date(diff_ms); 
    
      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },

  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .modal-container {
    background: $sec0;
    width: 40%;
    margin-left: 30%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .modal-body {
      background: $sec0;
      padding: $spacing-base;

      .modal-header {
        display: flex;
        align-items: center;
        padding-bottom: $spacing-base;

        .challenge-details {
          flex: 1;
          margin-left: $spacing-base;
          display: flex;
          flex-direction: column;
          position: relative;

          h3 {
            color: #FFF;
            padding: 0;
            margin: 0;
            font-size: $font-size-medium;
            display: inline-block;
          }

          p {
            margin: 0;
            padding: 0;
            font-size: $font-size-small;
            color: $sec4;
            font-weight: normal;
          }
        }

        .challenge-image {
          display: inline-block;
          width: 80px;
          height: 80px;
        }
        .icon {
          margin-left: -14px;
          margin-top: -50px;
        }
        i {
          color: $sec4;
          cursor: pointer;
        }
      }
    }
  }
}

.modal-row {
  display: flex;
  margin-bottom: $spacing-base;
  gap: $spacing-small;
  label {
    display: block;
    color: $sec6;
    font-size: $font-size-x-small;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  span {
    color: $sec4;
    font-size: $font-size-small;
  }

  .completed {
    font-size: $font-size-large;
    color: #FFF;
  }
}

.modal-input {
  flex: 1;

  a {
    text-decoration: none;
    color: $blue;
  }
}

.picture-option {
  margin-left: 0;
}

.modal-footer {
  background: $sec1;
  padding: $spacing-base;
  display: flex;
  flex-direction: column;
  gap: $spacing-small;

  .secondary-btn-dark {
    border-color: #FFF;
    color: #FFF;
    font-size: $font-size-x-small;
  }

  .primary-btn {
    float: right;
  }
  
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.body {
  label {
    font-size: $font-size-base;
    font-weight: 500;
    color: $sec6;
    margin-bottom: $spacing-small;
    display: block;
  }

  select {
    background-color: $sec0;
    width: 100%;
    margin-bottom: $spacing-small;
  }
}

.user-search-ttl { 
  color: #FFF;
  font-size: $font-size-base;
}

.search-field {
  input {
    background: $dark;
    width: 100%;
    box-sizing: border-box;
  }
}

.user-list {
  max-height: 200px;
  position: absolute;
  overflow: scroll;
  background: #0E0F15;
  top: 103px;
  width: calc(100% - 1px);
  box-sizing: border-box;

  .user {
    padding: 8px;
  }
  .user:hover {
    cursor: pointer;
    background: #16171e;
  }
}

.blank-image {
  width: 80px;
  height: 80px;
  border-radius: 80px;
  background: $sec7;
  display: inline-block;
}
.user-profile {
  display: inline-block;
  border-radius: 80px;
  width: 80px;
  height: 80px;
}
.icon {
  margin-left: -20px;
  position: absolute;
}
i {
  color: $sec4;
  cursor: pointer;
}
.user-details {
  flex: 1;
  margin-left: 16px;
  display: inline-block;
  margin-bottom: 16px;

  h3 {
    color: #FFF;
    padding: 0;
    margin: 0;
    font-size: $font-size-medium;
    display: inline-block;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: $font-size-small;
    color: $sec5;
    font-weight: bold;
    text-transform: uppercase;
  }
}

.empty {
  h4 {
    text-align: center;
    color: #0e0f15;
  }
}
</style>